import {useCallback, useEffect} from 'react';

import {AccessContact} from '../../interfaces/access-contact.interface';
import {Patient} from '../../interfaces/entities/patient.interface';
import {useStores} from '../use-stores';

export const useAccessesContacts = (
  patientId: Patient['id']
): {
  items: ReadonlyArray<AccessContact>;
  loading: boolean;
  errorLoading: boolean;
  reload: () => void;
} => {
  const {accessesStore: store} = useStores();

  const reload = useCallback(() => {
    store.fetchAccessContacts(patientId);
  }, [patientId, store]);

  useEffect(reload, [reload]);

  const errorLoading = !!store.errorLoadingContactsByPatientId[patientId];

  return {
    items: store.contactsByPatientId[patientId] || [],
    loading:
      !!store.loadingContactsByPatientId[patientId] || (!store.contactsByPatientId[patientId] && !errorLoading),
    errorLoading,
    reload,
  };
};
